import { deepMerge } from '@websolutespa/bom-core';
import { mockApp } from './mock-app.default.js';
import { mockThread } from './mock-thread.default.js';

const MOCK_APP = mockApp;
const MOCK_THREAD = mockThread;
function getMock(locale, test) {
  let app = locale in MOCK_APP ? MOCK_APP[locale] : MOCK_APP;
  let thread = locale in MOCK_THREAD ? MOCK_THREAD[locale] : MOCK_THREAD;
  if (typeof test === 'object') {
    if (test.app) {
      const testApp = locale in test.app ? test.app[locale] : test.app;
      app = deepMerge(app, testApp);
    }
    if (test.thread) {
      const testThread = locale in test.thread ? test.thread[locale] : test.thread;
      thread = testThread;
    }
  }
  return {
    app,
    thread
  };
}
function getMockApp(locale, threadId, test) {
  const mock = getMock(locale, test);
  const app = mock.app;
  if (threadId) {
    const thread = mock.thread;
    app.thread = {
      messages: thread.map(x => {
        let content = '';
        if (x.chunks.length === 1 && typeof x.chunks[0] === 'string') {
          content = x.chunks[0];
        } else {
          content = x.chunks.map(x => JSON.stringify(typeof x === 'string' ? {
            type: 'text',
            text: x
          } : x)).join(',');
          content = content.replace(/\n$/, '') + ',';
        }
        const message = {
          role: x.role,
          content
        };
        return message;
      }),
      threadId
    };
  }
  return app;
}
function getMockChunks(index, locale, test) {
  const mock = getMock(locale, test);
  const chunks = [];
  const message = mock.thread[index] || {
    chunks: ['I\'m a teapot.\n'],
    role: 'assistant'
  };
  if (message && message.role === 'assistant') {
    message.chunks.forEach(chunk => {
      {
        if (typeof chunk === 'string') {
          chunks.push(...chunk.split(' ').map((x, i, a) => `${x}${i < a.length - 1 ? ' ' : ''}`));
        } else if (chunk.type === 'string') {
          const content = chunk.content;
          if (content) {
            chunks.push(...content.split(' ').map((x, i, a) => `${x}${i < a.length - 1 ? ' ' : ''}`));
          }
        } else {
          chunks.push(chunk);
        }
      }
    });
  }
  return chunks;
}
function getMockPrompt(index, locale, test) {
  const mock = getMock(locale, test);
  const message = mock.thread[index];
  if (message && message.role === 'user') {
    return message.chunks[0];
  }
  return undefined;
}

export { getMock, getMockApp, getMockChunks, getMockPrompt };
//# sourceMappingURL=mock.js.map
